<template>
  <vx-card>
    <div class="flex flex-row justify-between">
      <h4>Payment Methods</h4>
      <p class="cursor-pointer mr-10 add-btn font-semibold" @click="addPaymentMethod()">Add</p>
    </div>
    <vs-divider />
    <div v-if="!isLoading">
      <div v-if="cards.length > 0">
        <div v-for="(card, index) in cards" :key="index">
          <div class="flex flex-row justify-between mt-5">
            <div class="flex flex-row">
              <img :src="require(`@/assets/images/cardsLogos/${card.cardImg}.svg`)" />
              <div class="ml-4 card-details">
                <div class="flex flex-row">
                  <p class="font-semibold">
                    <span class="mr-2">{{ card.cardBrand }}</span> * * * * {{ card.lastFourDigits }}
                  </p>
                  <p v-if="card.isDefaultCard" class="ml-4 font-semibold default-badge p-1">Default</p>
                </div>
                <p>Expires {{ card.expiryMonth }} {{ card.expiryYear }}</p>
              </div>
            </div>
            <div class="mr-4 flex align-center">
              <feather-icon icon="TrashIcon" svgClasses="h-5 w-5" class="mr-2 cursor-pointer" @click="deleteCardPromt(card)" />
              <button :disabled="card.isDefaultCard" @click="changeDefaultCard(card.cardId, card.cardBrand, card.lastFourDigits)" class="check-btn">
                <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" :class="card.isDefaultCard === 'true' ? 'ml-4' : 'check-icon ml-4 cursor-pointer'" />
              </button>
            </div>
          </div>
          <vs-divider />
        </div>
      </div>
      <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning" v-else>
        <p>No Payment Cards Available</p>
      </vs-alert>
    </div>
    <vs-alert v-else class="h-full my-4" color="primary">
      <p>Fetching Payment Methods......</p>
    </vs-alert>
  </vx-card>
</template>

<script>
import { getStripeForCloudifyUrl } from '@/utils/misc'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import axios from 'axios'
export default {
  name: 'PaymentMethods',
  data() {
    return {
      cards: [],
      stripeCustomerId: null,
      isLoading: true,
    }
  },
  methods: {
    /**
     * This function fetch the user card details from the autocode stripe endpoint and shows the available cards to the user.
     */
    async fetchCardDetails() {
      try {
        const userId = this.$store.state.admin.access ? this.$store.state.DB.owner : firebase.auth().currentUser.uid
        const cust = await firebase.firestore().collection('customers').doc(userId).get()
        if (!cust.exists) {
          console.log('No stripe customer found in firestore')
        } else {
          this.stripeCustomerId = cust.data().stripeId
        }
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        const { data: res } = await axios.get(`${getStripeForCloudifyUrl()}/getCustomerPaymentMethods?customerId=${this.stripeCustomerId}`)
        for (const card of res.data) {
          this.cards.push({
            cardId: card.id,
            cardBrand: card.card.brand[0].toUpperCase() + card.card.brand.substring(1),
            expiryMonth: months[card.card.exp_month - 1].substring(0, 3),
            expiryYear: card.card.exp_year,
            lastFourDigits: card.card.last4,
            cardImg: this.cardImage(card.card.brand),
            isDefaultCard: card.id === res.default_payment_method,
          })
        }
        this.$rollbar.info(`Fetched Payment Methods for ${this.stripeCustomerId}`, { data: this.cards })
      } catch (error) {
        this.$rollbar.error(`Error While Fetching Card Details For Customer: ${this.stripeCustomerId}`, { error })
      }
      this.isLoading = false
    },

    /**
     * This function is used to show the image for the respective payment card if there is no image for the card then we will show the default image.
     * @param {string} cardBrand This is the payment network name of the user.
     * @returns {string} Returns a string that contains the card brand name to show the image if the image is not present with the card brand name then we will return the defaul card image.
     */
    cardImage(cardBrand) {
      if (cardBrand === 'mastercard' || cardBrand === 'visa' || cardBrand === 'amex') {
        return cardBrand
      } else {
        return 'default-card'
      }
    },

    /**
     * This function is used to create a new card from autocode stripe endpoint and it will return a object that contains a url to create a new payment card.
     * @param {string} stripeCustomerId This is the stripeCustomerId of the user.
     * @param {string} revertBackUrl This is the revertBackUrl we used to navigate the user after the successfull payment card added
     */
    async addPaymentMethod() {
      try {
        const { data: res } = await axios.post(`${getStripeForCloudifyUrl()}/stripeAddCardPayment`, {
          customer: this.stripeCustomerId,
          revertBackUrl: window.location.href,
        })
        this.$rollbar.info(`Added New Card for ${this.stripeCustomerId}`, { data: res.data })
        window.open(res.url, '_self')
      } catch (error) {
        this.$rollbar.error(`Error Occurred While Adding A New Card For Customer: ${this.stripeCustomerId}`, { error })
      }
    },
    async deleteCardPromt(card) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you Sure?',
        text: `You are about Delete ${card.cardBrand} * * * * ${card.lastFourDigits}`,
        accept: this.deleteCard,
        parameters: [card.cardId],
        acceptText: 'Delete Payment Method',
      })
    },
    // This method is used to delete payment method of the client
    async deleteCard(parameters) {
      const paymentId = parameters[0]
      try {
        await axios.post(`${getStripeForCloudifyUrl()}/deleteCardPayment`, { paymentId })
        this.$rollbar.info(`Deleted Card ${paymentId} for client: ${this.stripeCustomerId}`)
        this.$vs.notify({
          title: 'Card Deleted Successfully',
          color: 'success',
          time: 4000,
        })
        this.$router.go()
      } catch (error) {
        this.$rollbar.error(`Error while deleting payment method for client: ${this.stripeCustomerId}`, { error })
        this.$vs.notify({
          title: 'Error Occured while deleting card',
          color: 'danger',
          time: 4000,
        })
      }
    },

    /**
     * This function is used to change the user default payment card by calling autocode stripe Endpoint.
     * @param {string} paymentId This the paymentId of the target card that the user clicked on.
     * @param {string} cardBrand This is the payment providers name of the target card that the user clicked on.
     * @param {number} cardNumber This is the payment card number of the target card that the user clicked on.
     */
    async changeDefaultCard(paymentId, cardBrand, cardNumber) {
      this.$vs.notify({
        title: 'Updating Payment Method',
        text: 'Please Wait . . .',
        color: 'primary',
      })
      try {
        await axios.post(`${getStripeForCloudifyUrl()}/changeDefaultPaymentMethod`, {
          customerId: this.stripeCustomerId,
          paymentMethodId: paymentId,
        })
        for (const item of this.cards) {
          if (item.cardId === paymentId) {
            item.isDefaultCard = true
          } else {
            item.isDefaultCard = false
          }
        }
        this.$vs.notify({
          title: 'Payment Method Updated',
          text: `Payment Method is Updated to ${cardBrand.toUpperCase()} * * * * ${cardNumber}`,
          color: 'success',
          time: 4000,
        })
        this.$rollbar.info(`${this.stripeCustomerId} Payment Method is Updated`)
      } catch (error) {
        this.$rollbar.error(`${this.stripeCustomerId} Updating Payment Method is Failed`, { error })
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.fetchCardDetails()
    }, 3000)
  },
}
</script>

<style scoped>
img {
  height: 69px;
  width: 69px;
}
.card-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.check-icon {
  color: #1f74ff;
}
.default-badge {
  background-color: #deeaff;
  border-radius: 3px;
  color: #1f74ff;
  font-weight: 600;
  font-size: 13px;
}
.check-btn {
  background-color: transparent;
  border: none;
}
.add-btn {
  color: rgb(152, 14, 243);
  font-size: 15px;
}
</style>
